<template lang="pug">
  validation-observer(ref='validation' tag='form')
    h3 Download de shapes dos processos
    .container
      app-divider(
        label="Upload planilha de processos",
      )
      div.form
        div.row
          app-label(label="Faça o upload da planilha para buscar os shapes dos processos:", :required="false")
          el-tooltip(
            effect='dark',
            placement="top"
          )
            i.el-icon-info.icon-info
            template(slot="content")  Para realizar a pesquisa de mais de um processo, insira a planilha contendo os números dos processos a serem pesquisados de acordo com o modelo a seguir.&nbsp
              a.btn-download(@click="baixarModelo") (Baixar modelo)
        app-upload-area(
          id="lote",
          :target="'publico/upload'"
          :fileType="validExtensions"
          :onSuccess="onSuccess"
          :documento="documento"
          :hasDownloadButton="false",
          v-model="documento"
          @removerDocumento="removerDocumento"
        )
    div.buttons
      el-button(v-if="carregando", type="primary" :loading="carregando") Carregando...
      el-button(v-if="podeBaixar" type='primary' @click="downloadShape()")
        | Baixar shapes
        i.el-icon-download.el-icon-right

</template>
<script>
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import AppUploadArea from '@/components/AppUploadArea'
import FileHelper from '@/utils/fileHelper'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import axios from '@/utils/api'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    AppDivider,
    AppUploadArea,
    AppLabel
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      urlUpload: this.$rotas.PUBLICO.UPLOAD,
      validExtensions: ['xlsx', 'xls', 'csv'],
      documento: null,
      usuario: null,
      carregando: false,
      podeBaixar: false,
      zip: null
    }
  },

  async created () {
    this.usuario = await this.getUsuario()
  },

  computed: {
    ...mapState({
      ORGAO: state => state.userInterface.dadosEstado.ORGAO
    }),
    isDisabledResponsavel () {
      return this.ordemServico === null || this.isRetificacao
    }
  },

  methods: {
    ...mapActions({
      downloadDocumentos: 'documentoArrecadacao/download',
      gerarComprovanteAction: 'upload/gerarComprovante',
      getModeloRelatorio: 'dashboardRelatorios/downloadModelo',
      getShapesByNumerosProcessos: 'processo/getShapesByNumerosProcessos',
      extrairNumerosProcesso: 'planilha/extrairNumerosProcesso',
      getUsuario: 'auth/getUsuario'
    }),
    async onSuccess (id, resumableFile, fileKey) {
      this.carregando = true
      this.documento = {
        id: this.documento ? this.documento.id : null,
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size,
        removed: false
      }
      const numerosProcesso = await this.extrairNumerosProcesso(this.documento.fileKey)
      if (!numerosProcesso || numerosProcesso.length <= 0) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TIPO_WARNING,
          'A planilha precisa conter pelo menos um número de processo. Por favor, revise e atualize a planilha.')
        this.carregando = false
        return
      }
      this.getShapesByNumerosProcessos({ numerosProcesso }).then(resp => {
        this.zip = resp
        this.podeBaixar = true
      })
      this.carregando = false
    },
    async download (id) {
      const documento = this.documento
      const arrayBuffer = await this.downloadDocumentos({ fileKey: documento.fileKey, id: documento.id })
      FileHelper.saveFile(arrayBuffer, documento.nomeOriginal)
    },
    removerDocumento () {
      this.documento = null
    },

    async enviar () {
      const valido = await this.$refs.validation.validate()

      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.ERRO_VALIDACAO_FINALIZAR_CADASTRO)
        return
      }
      const form = null

      await axios({
        method: 'POST',
        url: 'uploadcadastro/create',
        data: form
      })
        .then((res) => {
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.SUCESSO_CADASTRO_RECEPTOR_INTERNO)
          this.documento = null
          this.success(res)
        })
    },
    onError () {
      this.documento = null
    },
    baixarModelo () {
      this.getModeloRelatorio()
    },
    downloadShape () {
      const byteCharacters = atob(this.zip.file)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'application/zip' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', this.zip.name)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }
  }
}
</script>
<style scoped>
.margin-top {
  margin-top: 30px;
}

.buttons {
  display: flex;
  justify-content: center;
}
.height-upload {
  height: 200px;
}

.margin-bottom {
  margin-bottom: 30px;
}

.input {
  width: 100%;
}
.radio-buttons {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.label {
  margin-top: 20px;
}

.container {
  background-color: #f8f8f8;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  padding: 0.2% 1.5%;
  gap: 4%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
}

.btn-download {
  text-decoration: underline;
  cursor: pointer;
  color: #f1f1f1;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.icon-info {
  font-size: 25;
  margin: 0 0 -5px 5px;
}

</style>



// WEBPACK FOOTER //
// src/screens/diagnostico/DownloadShapes.vue